


































































































import pdfService from "@/views/offer/pdf.service";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Machine } from "@/models/machine";
import { RepositoryFactory } from "@/api/RepositoryFactory";
import { MachinePdf, MachinePdfType } from "@/models/machinePdf";
import DocumentPdfRepository from "@/api/DocumentPdfRepository";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import VuePdf from "vue-pdf/src/vuePdfSss.vue";
import PdfTypeCardComponent from "../PdfTypeCard.component.vue";
import { Maintenance } from "@/models/maintenance";


const pdfRepository: DocumentPdfRepository = RepositoryFactory.get('documentpdf');

@Component({
  methods: { pdfService },
  components: {
    PdfCardComponent: () => import('./../PdfCard.component.vue'),
    VuePdfEmbed,
    VuePdf,
    PdfTypeCardComponent
  }
})

export default class DocumentPdfDialogComponent extends Vue {

  @Prop({ default: () => new Machine({}) })
  public machine!: Machine;

  @Prop({ default: () => new Maintenance({}) })
  public maintenance!: Maintenance;

  @Prop({ default: false })
  public machineView!: boolean;

  public dragover: boolean = false;

  public uploadedFiles: Array<any> = [];
  public fetchedFiles: Array<any> = [];

  public pdfTypes: any[] = [];

  // Make MachinePdfType available in template
  public MachinePdfType = MachinePdfType;


  public async mounted() {


    if (this.machineView) {
      this.pdfTypes = Object.values(MachinePdfType)
        .filter(type => type !== MachinePdfType.pdfTUV)
        .map(type => ({
          value: type, 
          text: type.replace('pdf', '')
        }));
    } else {
      this.pdfTypes = Object.values(MachinePdfType)
        .filter(type => type === MachinePdfType.pdfTUV)
        .map(type => ({
          value: type, 
          text: type.replace('pdf', '')
        }));
    }


    if (this.machineView) {
      this.fetchedFiles = this.machine.documentPdfs;
    } else {
      this.fetchedFiles = this.maintenance.documentPdfs;
    }


  }


  removeFile(filename: string) {
    // Find the index of the
    const index = this.uploadedFiles.findIndex(
      file => file.name === filename
    );
    // If file is in uploaded files remove it
    if (index > -1) this.uploadedFiles.splice(index, 1);
  }

  onDrop(dropEvent: any) {
    this.dragover = false;
    // If there are already uploaded files remove them
    if (this.uploadedFiles.length > 0)
      this.uploadedFiles = [];
    else {
      const files = Array.from(dropEvent.dataTransfer.files);
      files.forEach((element: any) => {
        // Set default PDF type based on view
        element.pdfType = this.machineView ? MachinePdfType.pdfElektro : MachinePdfType.pdfTUV;
        element.url = URL.createObjectURL(element);
        this.uploadedFiles.push(element)
      }
      );
    }
  }

  public async downloadFile(item: MachinePdf) {

    try {
      const blobResponse = await pdfRepository.getPDFDocument(item)
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blobResponse.data);
      link.download = item.filename;
      
      document.body.append(link);
      link.click();
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    } catch (e) {
      console.log('error');
    }
  }


  public async deleteFile(pdfDoc: MachinePdf) {

    if (this.machineView) {
      try {
        const response = await pdfRepository.deletePdf(pdfDoc);
        if (response.data.id) {
          this.machine.documentPdfs = this.machine.documentPdfs.filter(pdf => pdf.id !== pdfDoc.id);
          this.fetchedFiles = this.machine.documentPdfs;
        }
      } catch (e) {
        // TODO: Show error
      }
    } else {
      try {
        const response = await pdfRepository.deletePdf(pdfDoc);
        if (response.data.id) {
          this.maintenance.documentPdfs = this.maintenance.documentPdfs.filter(pdf => pdf.id !== pdfDoc.id);
          this.fetchedFiles = this.maintenance.documentPdfs;
        }
      } catch (e) {
        // TODO: Show error
      }
    }
  }

  public async submit() {
    if (this.machineView) {
      try {
        const promises = this.uploadedFiles.map(file =>
          pdfRepository.uploadPdf(file, file.pdfType, {
            machine: this.machine,
            maintenance: null
          }));

        const responses = await Promise.all(promises);
        responses.forEach((pdfResponse, index) => {

          if (this.uploadedFiles[index]) {
            this.machine.documentPdfs.push(new MachinePdf(pdfResponse.data));

          }
        });
        this.uploadedFiles = [];
      } catch (e) {
        console.log('error');
      }
    } else {
      try {
        const promises = this.uploadedFiles.map(file =>
          pdfRepository.uploadPdf(file, file.pdfType, {
            maintenance: this.maintenance,
            machine: null
          }));
        const responses = await Promise.all(promises);
        responses.forEach((pdfResponse, index) => {
          if (this.uploadedFiles[index]) {
            this.maintenance.documentPdfs.push(new MachinePdf(pdfResponse.data));
          }
        });
        this.uploadedFiles = [];
      } catch (e) {
        console.log('error');
      }
    }
  }
}

